import { NgClass, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnChanges, signal, SimpleChanges } from '@angular/core';
import { TooltipDirective } from './tooltip/tooltip.directive';

@Component({
  selector: 'lib-token',
  standalone: true,
  imports: [NgClass, TooltipDirective, NgIf],
  styles: [
    `
      .text-red {
        color: red;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <span
      *ngIf="text?.length"
      class="relative flex h-10 w-10 cursor-pointer"
      [ngClass]="{ 'text-red': text === '-1' }"
      libTooltip
      [libTooltipTemplate]="tooltip"
      libTooltipPosition="top"
      libTooltipPositionOffset="8"
      libTooltipMode="hover">
      {{ text }}
    </span>
    <ng-template #tooltip let-date="date">
      <div *ngIf="tooltipText" class="rounded-lg border border-gray-200 bg-white px-3 py-2 text-sm shadow">
        {{ tooltipText }}
      </div>
    </ng-template>
  `,
  host: {
    class: 'block',
  },
})
export class TokenComponent implements OnChanges {
  @Input() text: string | undefined;
  @Input() tooltipText: string | undefined;

  animating = signal(false);

  ngOnChanges(changes: SimpleChanges) {
    if (changes['text'] && !changes['text'].isFirstChange()) {
      this.resetAnimation();
    }
  }

  resetAnimation() {
    this.animating.set(true);
    setTimeout(() => {
      this.animating.set(false);
    }, 2000);
  }
}
